@if (goals) {
  <div class="card-header p-1 border-adriatic"
    [ngClass]="{strategy: recordTypeName === 'Strategy', project: recordTypeName === 'Project' }">
    <div>
      <span class="text-success-800 font-weight-bold">{{recordTypeName}}</span><span
    class="text-muted ml-1">({{statusName}})</span>
  </div>
  <h4 class="hub-project-title mb-0">
    <a [routerLink]="'/portfolio/' + hubRecordId" class="font-weight-bold">{{project?.name}}</a>
  </h4>
</div>
@if (showCardDetails) {
  <div class="card-body m-1 p-1">
    <div class="description">
      <p class="record-description" [innerHTML]="project?.briefDescription"></p>
    </div>
    @if (!project?.briefDescription) {
      <p class="text-muted record-description">This record does not have a description.</p>
    }
    <hr>
      <div>
        @if (getProjectLeader()) {
          <span>
            Led by
            <a [routerLink]="'/user/' + getProjectLeader().userId" class="led-by-link">
              {{getProjectLeader().fullName}}
            </a>
          </span>
        }
      </div>
      <div>
        @if (getLeadBusinessUnit()) {
          <span>
            Managed by {{getLeadBusinessUnit().name}}
          </span>
        }
      </div>
      @if ((recordTypeName === 'Strategy') && project.relations?.length > 0) {
        <div class="supported-by-label"
          >
          Supported by
          {{project?.relations.length}} {{project?.relations.length === 1 ? 'Project' : 'Projects'}}:
        </div>
      }
      @if ((recordTypeName === 'Project') && project.relations?.length > 0) {
        <div class="supported-by-label">
          Supporting
          {{project?.relations.length}} {{project?.relations.length === 1 ? 'Strategy' : 'Strategies'}}:
        </div>
      }
      @if ((recordTypeName === 'Strategy' || recordTypeName === 'Project') && project.relations?.length > 0) {
        <div
          class="hub-custom-scrollbar"
          style="max-height: 200px; overflow-y: visible; overflow-x: hidden;">
          @if (recordTypeName === 'Project') {
            @for (relation of project?.relations; track relation) {
              <a [routerLink]="'/portfolio/' + relation.relatedProject.projectId"
              class="badge badge-primary mr-1 mb-1">{{relation.relatedProject.name}}</a>
            }
          }
          @if (recordTypeName === 'Strategy') {
            @for (relation of project?.relations; track relation) {
              <a [routerLink]="'/portfolio/' + relation.relatedProject.projectId"
              class="badge badge-primary mr-1 mb-1">{{relation.relatedProject.name}}</a>
            }
          }
        </div>
      }
      @if (showFinanceDetails) {
        <div class="details">
          <h4 class="text-indigo mt-0 mb-0 p-0">
            $ {{ numberWithCommas(getFinancial('currentFyBudget')) }}
          </h4>
          <span class="text-muted d-block m-0">FY{{ currentFiscalYear }} Working Budget</span>
          <div class="progress mt-1 mb-2" style="height: 0.5rem;">
            <div class="progress-bar"
            [ngStyle]="{'width.%': getFinancial('fundingPercent') | numberWithoutCommas}"></div>
          </div>
          <span class="text-muted">
            {{ getFinancial('fundingPercent') | numberWithoutCommas }}% Funded (of Working Budget)
          </span>
        </div>
      }
    </div>
  }
  <div class="goals-panel">
    @for (goal of getProjectGoals(); track goal) {
      <div class="goal-icon {{'goal-background-' + goal.goal2030Id}}"
      [matTooltip]="goal.theme" [matTooltipShowDelay]="500" [matTooltipHideDelay]="200"></div>
    }
  </div>
  <div class="card-footer d-flex justify-content-between align-items-center p-1">
    <div>
      <div class="card-footer-buttons">
        <a href="#" (click)="toggleFavorite(hubRecordId, $event)" class="text-primary">
          @if (userDataService.isFavorite(hubRecordId)) {
            <span class="material-icons-outlined">favorite</span>
          }
          @if (!userDataService.isFavorite(hubRecordId)) {
            <span class="material-icons-outlined">favorite_border</span>
          }
        </a>
        @if (isUserCanEdit) {
          <a [routerLink]="'/portfolio/' + hubRecordId + '/edit'" class="text-primary">
            <span class="material-icons-outlined">edit</span>
          </a>
        }
        <app-add-project-to-collection-button [projectId]="project.projectId" [projectName]="project.name"></app-add-project-to-collection-button>
        @if (userIsCreator) {
          <a href="javascript: void(0)"
            (click)="deleteRecordCollectionProjectClicked()"><i class="icon-trash"></i></a>
          }
        </div>
        <span class="text-muted font-size-sm ml-3">
          Updated {{ getDistanceInWordsToNow() }}
        </span>
      </div>
    </div>
  }